<template>
  <div id="feedback">
    <div class="inner">
      <el-row class="title">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark g-title">意见反馈</div>
        </el-col>
      </el-row>
      <el-form ref="form" :model="form" label-width="0" style="width:100%;margin-top: 20px;">
          <p style="margin-bottom: 10px;height: 20px;font-size: 15px;font-family: MicrosoftYaHei;color: #262626;line-height: 20px;">你有什么问题或者建议想对我们说？</p>
        <el-form-item style="margin-bottom:30px;" label="" prop="desc">
            <el-input type="textarea" maxlength="500" v-model="form.desc" placeholder="您的宝贵意见，就是我们前进的动力！（500字以内）"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button   type="primary"  class="theme-bg qd" @click="onSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        desc: ""
      }
    }
  },
  methods:{
      onSubmit(){
        this.form.desc = this.form.desc.trim();
        this.form.desc = this.form.desc.replace(/'/g,"&#x27;");
        console.log(this.form.desc);
        if(this.form.desc==''){
          this.$alert('请输入内容', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
          })
          return false
        }
       this.$api.get('user/user/opinion',{
         id_example:this.$store.state.id_example,
         token_user:this.$store.state.user_id,
         content:this.form.desc
       },res=>{
         if(res.data.code==100){
           this.$alert(res.data.data, res.data.message, {
              confirmButtonText: '确定',
              callback: action => {
                this.form.desc = "";
              }
            });
         }
       })
     }
  }
};
</script>
<style lang="less" scoped>
.qd{
width: 315px !important;
height: 48px !important;
background: #E23130;
border-radius: 6px;
color: #fff !important;
border: 1px solid #E23130;
transition: all 0.5s !important;
}
.qd:hover{border: 1px solid #E23130 !important;}
 .g-title{
    height: 40px;
font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 40px;
border-bottom: dashed 1px rgba(151,151,151,0.5);
padding-bottom: 8px;
  }
#feedback {
  width: 985px;
  min-height: 572px;
  float: left;
  background: #fff;
  box-shadow: 0px 9px 13px 0px rgba(190, 190, 190, 0.2);
  textarea{
    width: 100% !important;
    height: 143px !important;
background: #FAFAFA  !important;
border: 1px solid #D6DEE9 !important;
  }
 /deep/ .el-textarea__inner{
      width:100%;
      height: 143px !important;
     background: #FAFAFA  !important;
border: 1px solid #D6DEE9 !important;
transition: all 0.5s;
        &:hover{
        border:solid 1px #b8bfc9 !important;
      }
&:focus{
  border: 1px solid #E23130 !important;
}
  }
  .inner {
    box-sizing: border-box;
    padding: 10px 30px;
    .inputbox {
      // margin: 40px;
         width: 100%;
    height: 220px;
    resize: none;
    font-size: 13px;
    height: 143px;
    background: #FAFAFA;
    border: 1px solid #D6DEE9;
      input {
        width: 100%;
        line-height: 34px;
        border: none;
      }
    }
    button {

      text-align: center;
    }
     button:hover{
        border-bottom: 1px solid #F83132 !important;
        box-shadow: none;
     }
    .act{
        color: #F83132;
        border-bottom: 1px solid #F83132;
    }
  }
  .handleNav {
    height: 40px;
    background: #e3e3e3;
    border: 1px solid #ddd;
    margin-top: 55px;
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .name1 {
      width: 370px;
      margin-left: 20px;
      text-align: left;
    }
    .name2 {
      width: 240px;
    }
    .name3 {
      width: 270px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/cont/feedback.vue